import { defineMessages } from 'react-intl';

export const moneyAccountsMessages = defineMessages({
    accounts: {
        id: 'accounts',
        defaultMessage: 'Accounts',
    },
    account: {
        id: 'account',
        defaultMessage: 'Account',
    },
    iban: {
        id: 'iban',
        defaultMessage: 'IBAN',
    },
    isActive: {
        id: 'is-active',
        defaultMessage: 'Is active',
    },
    createMoneyAccountSuccess: {
        id: 'create-money-account-success',
        defaultMessage: 'Money account created',
    },
    createMoneyAccountSuccessDescription: {
        id: 'create-money-account-success-description',
        defaultMessage: 'Money account {entry} has been successfully created.',
    },
    addMoneyAccountSubtitle: {
        id: 'add-money-account-subtitle',
        defaultMessage: 'Create a new money account',
    },
    reference: {
        id: 'reference',
        defaultMessage: 'Reference',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    cash: {
        id: 'cash',
        defaultMessage: 'Cash',
    },
    bank: {
        id: 'bank',
        defaultMessage: 'Bank',
    },
    card: {
        id: 'card',
        defaultMessage: 'Card',
    },
    online: {
        id: 'online',
        defaultMessage: 'Online',
    },
    processor: {
        id: 'processor',
        defaultMessage: 'Processor',
    },
    eur: {
        id: 'eur',
        defaultMessage: 'EUR',
    },
    gbp: {
        id: 'gbp',
        defaultMessage: 'GBP',
    },
    usd: {
        id: 'usd',
        defaultMessage: 'USD',
    },
    deleteMoneyAccount: {
        id: 'delete-money-account',
        defaultMessage: 'Delete money account',
    },
    deleteMoneyAccountSuccess: {
        id: 'delete-money-account-success',
        defaultMessage: 'Money account deleted',
    },
    deleteMoneyAccountSuccessDescription: {
        id: 'delete-money-account-success-description',
        defaultMessage: 'The money account has been successfully deleted.',
    },
    confirmDeleteMoneyAccount: {
        id: 'confirm-delete-money-account',
        defaultMessage: 'Are you sure you want to delete this money account? This action cannot be undone.',
    },
    deleteMoneyAccountSubtitle: {
        id: 'delete-money-account-subtitle',
        defaultMessage: 'Permanently delete money account {entity}',
    },
    editMoneyAccountSubtitle: {
        id: 'edit-money-account-subtitle',
        defaultMessage: 'Edit money account {entity}',
    },
    updateMoneyAccountSuccess: {
        id: 'update-money-account-success',
        defaultMessage: 'Money account updated',
    },
    updateMoneyAccountSuccessDescription: {
        id: 'update-money-account-success-description',
        defaultMessage: 'Money account {entity} has been successfully updated.',
    },
    moneyAccounts: {
        id: 'money-accounts',
        defaultMessage: 'Money accounts',
    },
    moneyAccountsWithPaymentsError: {
        id: 'custom-error:change_billing_entity_of_money_account_with_payments',
        defaultMessage:
            'The billing entity related to money account with existing payments cannot be changed or deleted!',
    },
});
